// eslint-disable-next-line no-unused-vars
import { MaintenanceItem } from '@clients/bff'
import fnsSubDays from 'date-fns/subDays'
import fnsFormat from 'date-fns/format'

export function mapReminderTrigger (value: MaintenanceItem) {
  const trigger = {
    due: 'Fällig',
    overdue: 'Überfällig',
    period: 'Fälligkeit: '
  }
  let periodReminder: boolean = false
  let dueNow: boolean = false
  let overdueNow: boolean = false

  if (value.dateTrigger) {
    const calcDueDate = fnsSubDays(new Date(), value.dateTrigger.due)
    const calcOverdueDate = fnsSubDays(new Date(), value.dateTrigger.overdue)
    const dueDate = fnsFormat(calcDueDate, 'dd.MM.yyyy')
    const overdueDate = fnsFormat(calcOverdueDate, 'dd.MM.yyyy')
    const periodDate = value.dateTrigger.period
    const optionalOrWord = value.odometerTrigger ? ' oder ' : ''

    if (value.dateTrigger.due === 0) {
      trigger.due += ': Jetzt'
      dueNow = true
    } else {
      trigger.due += ` am: ${dueDate}${optionalOrWord}`
    }

    if (value.dateTrigger.overdue === 0) {
      trigger.overdue += ': Jetzt'
      overdueNow = true
    } else {
      trigger.overdue += ` am: ${overdueDate}${optionalOrWord}`
    }

    if (periodDate) {
      trigger.period += `${periodDate}${optionalOrWord}`
      periodReminder = true
    }
  }

  if (value.odometerTrigger) {
    if (!dueNow) {
      if (value.odometerTrigger.due < 0) {
        trigger.due += ` in ${-value.odometerTrigger.due} km`
      } else if (value.odometerTrigger.due > 0) {
        trigger.due += ` seit ${value.odometerTrigger.due} km`
      } else {
        trigger.due = 'Fällig: Jetzt'
      }
    }

    if (!overdueNow) {
      if (value.odometerTrigger.overdue < 0) {
        trigger.overdue += ` in ${-value.odometerTrigger.overdue} km`
      } else if (value.odometerTrigger.overdue > 0) {
        trigger.overdue += ` seit ${value.odometerTrigger.overdue} km`
      } else {
        trigger.overdue = 'Überfällig: Jetzt'
      }
    }

    if (value.odometerTrigger.period) {
      trigger.period += value.odometerTrigger.period
      periodReminder = true
    }
  }

  if (!periodReminder) {
    trigger.period = undefined
  }
  return trigger
}
